import { parsePhoneNumber } from 'libphonenumber-js';
export const formatPhoneNumber = (phone, countryCode) => {
    let _countryCode = countryCode;
    if (_countryCode === null || _countryCode === void 0 ? void 0 : _countryCode.startsWith('+')) {
        _countryCode = _countryCode.split('+')[1];
    }
    const parsed = parsePhoneNumber(phone, { defaultCallingCode: _countryCode });
    return parsed.formatNational();
};
